import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { withUser } from '../../auth/withUser';
import { history } from '../../../history';

export class LoggedOutUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.checkUser = this.checkUser.bind(this);
  }

  checkUser() {
    const { user } = this.props;
    if ((user.get('userName'))) {
      history.push('/view');
    }
  }

  componentDidMount() {
    this.checkUser();
  }

  componentDidUpdate() {
    this.checkUser();
  }

  render() {
    return (<h2>You have been logged out.</h2>);
  }
}

LoggedOutUnwrapped.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
};

export const LoggedOut = withUser(LoggedOutUnwrapped);
